const TARGET_SAMPLE_RATE = 16_000;
export async function decodeToPcm(bytes, _mimeType) {
    const arrayBuffer = bytes instanceof Uint8Array
        ? bytes.slice().buffer
        : bytes;
    const AudioContextCtor = globalThis
        .AudioContext ??
        globalThis.webkitAudioContext;
    if (!AudioContextCtor) {
        throw new Error('decodeToPcm: AudioContext is not available in this context');
    }
    const probeCtx = new AudioContextCtor();
    let decoded;
    try {
        decoded = await probeCtx.decodeAudioData(arrayBuffer);
    }
    finally {
        await probeCtx.close().catch(() => undefined);
    }
    const targetLength = Math.max(1, Math.ceil(decoded.duration * TARGET_SAMPLE_RATE));
    const offlineCtx = new OfflineAudioContext(1, targetLength, TARGET_SAMPLE_RATE);
    const source = offlineCtx.createBufferSource();
    source.buffer = decoded;
    // Connecting a multi-channel source into a 1-channel destination
    // triggers the Web Audio spec's default down-mix — no manual channel
    // merging needed.
    source.connect(offlineCtx.destination);
    source.start(0);
    const rendered = await offlineCtx.startRendering();
    return { pcm: rendered.getChannelData(0).slice(), sampleRate: TARGET_SAMPLE_RATE };
}
